import React, { useState } from 'react';
import useFetch from 'use-http';
import AnimateHeight from 'react-animate-height';
import { DialogActionBar } from 'src/components/common/Dialog.redesign';
import FormRow from 'src/components/controls/forms/common/FormRow';
import SelectInput from 'src/components/controls/forms/common/SelectInput';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { SelectItem } from 'src/models/common/SelectItem';
import IOwner from 'src/models/IOwner';
import CreateBOLM from './CreateBOLM';
import CreateBusiness from './CreateBusiness';
import CreateIndividual from './CreateIndividual';
import CreateRAL from './CreateRAL';
import CreateStateLand from './CreateStateLand';
import CreateTrust from './CreateTrust';
import State from 'src/models/State';
import PhoneNumberType from 'src/models/PhoneNumberType';
import CreateJointTenant from './CreateJointTenant';

export type CreateOwnerAction = {
    id: number;
    intent: string;
    text: string;
    action: () => void;
    isSave: boolean;
};

interface ICreateOwner {
    onOwnerCreated: (data: IOwner) => void;
    actions: CreateOwnerAction[];
}

const CreateOwner: React.FC<ICreateOwner> = (props) => {
    const [ownerType, setOwnerType] = useState(0);
    const [states, setStates] = useState<Array<SelectItem>>();
    const [phoneNumberTypes, setPhoneNumberTypes] = useState<Array<PhoneNumberType>>(undefined);
    const { get, response } = useFetch();

    const loadStates = async () => {
        const result = await get('v1.0/states?$skip=0&$top=100');

        if (response.ok) {
            setStates(result.items.map((state: State) => new SelectItem(state.id, state.abbreviation)));
        }
    };

    const loadPhoneTypes = async () => {
        const result = await get('v1.0/PhoneNumberTypes');

        if (response.ok) {
            setPhoneNumberTypes(result);
        } else {
            console.log('Unable to get Phone Number Types!!');
        }
    };

    React.useEffect(() => {
        loadStates();
        loadPhoneTypes();
    }, []);

    const ownerTypeChange = (value: number) => {
        setOwnerType(value);
    };

    const items: Array<SelectItem> = [
        { id: 1, name: 'Individual' },
        { id: 2, name: 'Business' },
        { id: 3, name: 'Trust' },
        { id: 4, name: 'Gov-BOLM' },
        { id: 5, name: 'Gov-RAL' },
        { id: 6, name: 'Gov-STATE' },
        { id: 7, name: 'Joint Tenant' },
    ];

    const actions = () => {
        if (props.actions && props.actions.length > 0) {
            return props.actions.map((a: CreateOwnerAction) => {
                if (a.isSave) {
                    return <Button key={a.id} disabled={true} intent={a.intent} text={a.text} onClick={undefined} />;
                } else {
                    return <Button key={a.id} intent={a.intent} text={a.text} onClick={a.action} />;
                }
            });
        }
        return <></>;
    };

    const renderForm = () => {
        switch (ownerType) {
            case 1:
                return <CreateIndividual states={states} phoneNumberTypes={phoneNumberTypes} {...props} />;
            case 2:
                return <CreateBusiness states={states} phoneNumberTypes={phoneNumberTypes} {...props} />;
            case 3:
                return <CreateTrust states={states} phoneNumberTypes={phoneNumberTypes} {...props} />;
            case 4:
                return <CreateBOLM states={states} phoneNumberTypes={phoneNumberTypes} {...props} />;
            case 5:
                return <CreateRAL states={states} phoneNumberTypes={phoneNumberTypes} {...props} />;
            case 6:
                return <CreateStateLand states={states} phoneNumberTypes={phoneNumberTypes} {...props} />;
            case 7:
                return <CreateJointTenant states={states} phoneNumberTypes={phoneNumberTypes} {...props} />;
            default:
                return (
                    <>
                        <div>Select Owner Type...</div>
                        <DialogActionBar>{actions()}</DialogActionBar>
                    </>
                );
        }
    };

    return (
        <div style={{ minWidth: '80rem' }}>
            <FormRow layout={[5, '8_']} className="mb-2" style={{ marginTop: '0' }}>
                <SelectInput label="Owner Type" options={items} onChange={ownerTypeChange} isCreatable={true} />
            </FormRow>
            <AnimateHeight height="auto" duration={300} animateOpacity={true}>
                {renderForm()}
            </AnimateHeight>
        </div>
    );
};

export default CreateOwner;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/createOwner/CreateOwner.tsx